var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.4656 56 56 43.4656 56 28C56 12.5344 43.4656 0 28 0C12.5344 0 0 12.5344 0 28C0 43.4656 12.5344 56 28 56ZM23.625 36.75H26.25V29.75H23.625C22.1703 29.75 21 28.5797 21 27.125C21 25.6703 22.1703 24.5 23.625 24.5H28.875C30.3297 24.5 31.5 25.6703 31.5 27.125V36.75H32.375C33.8297 36.75 35 37.9203 35 39.375C35 40.8297 33.8297 42 32.375 42H23.625C22.1703 42 21 40.8297 21 39.375C21 37.9203 22.1703 36.75 23.625 36.75ZM28 21C26.0641 21 24.5 19.4359 24.5 17.5C24.5 15.5641 26.0641 14 28 14C29.9359 14 31.5 15.5641 31.5 17.5C31.5 19.4359 29.9359 21 28 21Z",
    fill: "#1C3879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/About-Icon.acf200c8.svg";
export { ForwardRef as ReactComponent };